import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export function scrollToHash(hash) {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -90, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
